import { AvatarFrameId } from '../profile/frames';
import { duration } from '../utils/duration';
import { DaysOfTheWeek } from '../utils/time';
import { tuple } from '../utils/types';

export enum TeamRole {
  Admin = 'admin',
  Member = 'member',
}

export const MAX_CHAT_MESSAGES = 250;
export const DISPLAYED_CHAT_MESSAGES = 25;
export const MAX_MEMBERS = 50;
export const MAX_TEAM_SUGGESTIONS = 50;
export const MAX_TEAM_LEADERBOARD = 100;
export const TEAM_CREATION_COST = 50;
export const TEAM_EVENT_EXPIRATION = duration({ days: 30 });
export const HELP_REQUEST_EXPIRATION = duration({ days: 10 });

export type TeamEventType = 'competition' | 'chest';

export const teamCompetitionSchedule: {
  type: TeamEventType;
  start: { day: DaysOfTheWeek; hour: number };
  end: { day: DaysOfTheWeek; hour: number };
}[] = [
  {
    type: 'chest',
    start: { day: 'sunday', hour: 23 },
    end: { day: 'thursday', hour: 23 },
  },
  {
    type: 'chest',
    start: { day: 'thursday', hour: 23 },
    end: { day: 'sunday', hour: 23 },
  },
];

export type ChatMessageType =
  | 'text'
  | 'emote'
  | 'energyRequest'
  | 'helpRequest'
  | 'event' // Competition event
  | 'chestEvent'; // Team chest event

// List of that emotes
export const chatEmoteIDs = tuple(
  'thumb',
  'normal',
  'happy',
  'love',
  'cry',
  'angry',
  'sad',
  'wink',
);

export type EmoteID = (typeof chatEmoteIDs)[number];

// List of text message IDs
export const textMessageIDs = tuple(
  'message1',
  'message2',
  'message3',
  'message4',
  'message5',
  'message6',
  'message7',
  'message8',
);

export type TextMessageID = (typeof textMessageIDs)[number];

export const energyRequestAmount = 5;
export const energyRequestCooldown = duration({ hours: 3 });

export type TeamMemberProfile = {
  name: string;
  role: TeamRole;
  avatar: string;
  frame: AvatarFrameId;
};

export type TeamMemberData = {
  id: string;
  profile: TeamMemberProfile;
  position: number;
  helps: number;
  level: number;
  me?: boolean;
};
